import React, { useState } from "react";
import "./style.css";
import SupportImg from "../images/support_img.png"
import config from "../../config/config.js";

export const View = () => {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");

    const handleSubmit = async () => {
        if (!name.trim() || !phone.trim()) {
            alert("⚠️ Заполните имя и телефон!");
            return;
        }

        try {
            const response = await fetch(
                `${config.apiUrl2}/api/orders/obratno-vizov-name`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "User-Agent": "insomnia/11.3.0",
                    },
                    body: JSON.stringify({
                        name: name,
                        phoneNumber: phone,
                    }),
                }
            );

            if (response.ok) {
                alert("✅ Заявка успешно отправлена! Мы скоро с вами свяжемся.");
                setName("");
                setPhone("");
            } else {
                alert("❌ Ошибка при отправке. Попробуйте снова.");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            alert("⚠️ Сервер недоступен. Попробуйте позже.");
        }
    };

    return (
        <section className="view-section">
            <h2 className="view-title">ОСТАЛИСЬ ВОПРОСЫ?</h2>

            <div className="view-content">
                <div className="view-form">
                    <input
                        type="text"
                        className="view-input"
                        placeholder="Ваше имя"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <input
                        type="text"
                        className="view-input"
                        placeholder="Ваш номер телефона"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                    <button className="view-button" onClick={handleSubmit}>
                        Отправить
                    </button>
                </div>

                <img
                    className="view-image"
                    src={SupportImg}
                    alt="contact illustration"
                />
            </div>
        </section>
    );
};
